import React from 'react';
import ROUTES from '@src/constants/route';
import { useLocation, useHistory } from 'react-router-dom';
import { Typography, DialogTitle, IconButton, Button } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import PaperFireworks from '@src/assets/images/paper-fireworks.svg';
import RewardCodeGrid from './RewardCodeGrid';
import { StyledJoinGroupZalo } from './index.style';

const TopUpBanner = ({
  handleClosePopup,
  open,
  rewardCodes = [],
  onViewCodes,
}) => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const isSupportedRoute = [
    ROUTES.MOBILE_TTS,
    ROUTES.TTS,
    ROUTES.DUBBING,
    ROUTES.HOME,
  ].includes(location.pathname);
  const hasRewardCodes = rewardCodes.length > 0;
  // With codes, "View my codes" is the only primary button.
  const isFirstButtonPrimary = isSupportedRoute && !hasRewardCodes;
  return (
    <StyledJoinGroupZalo
      isSupportedRoute={isSupportedRoute}
      open={open}
      fullWidth
    >
      <div className="dialog-content">
        <DialogTitle classes={{ root: 'dialog-title' }}>
          <IconButton
            aria-label="close"
            onClick={handleClosePopup}
            color="secondary"
            className="close-button"
          >
            <CloseRounded className="close-icon" sx={{ fontSize: 16 }} />
          </IconButton>
        </DialogTitle>

        <div className="dialog-wrapper">
          <div className="img-wrapper">
            <img src={PaperFireworks} alt="icon" className="img" />
          </div>
          <Typography className="title">
            {t('characterPurchaseSuccessful')}
          </Typography>

          <div className="description">
            {t('descriptioncharacterPurchaseSuccessful')}
          </div>
          {hasRewardCodes && (
            <div style={{ marginTop: 20 }}>
              <RewardCodeGrid codes={rewardCodes} />
            </div>
          )}
          <div className="button-container">
            <Button
              variant={isFirstButtonPrimary ? 'contained' : 'outlined'}
              className={
                isFirstButtonPrimary
                  ? 'action-button-contained'
                  : 'action-button-contained btn-outlined'
              }
              onClick={handleClosePopup}
            >
              {isSupportedRoute ? t('gotIt') : t('notNow')}
            </Button>
            {!isSupportedRoute && !hasRewardCodes && (
              <Button
                variant="contained"
                className="action-button-contained use-now-button"
                onClick={() => {
                  handleClosePopup();
                  history.push(ROUTES.TTS);
                }}
              >
                {t('useNow')}
              </Button>
            )}
            {hasRewardCodes && (
              <Button
                variant="contained"
                className="action-button-contained use-now-button"
                onClick={onViewCodes}
              >
                {t('topPaidEventViewMyCodes')}
              </Button>
            )}
          </div>
        </div>
      </div>
    </StyledJoinGroupZalo>
  );
};

export default TopUpBanner;
